"use strict";
import { Flex } from "ui/src/components/layout/Flex";
export function Inset({ all = "$spacing16", children }) {
  return <Flex p={all}>{children}</Flex>;
}
